//#region generated/gql/graphql.ts
let Integration = /* @__PURE__ */ function(Integration$1) {
	Integration$1["Adamai"] = "ADAMAI";
	Integration$1["Apple"] = "APPLE";
	Integration$1["Asana"] = "ASANA";
	Integration$1["Azuread"] = "AZUREAD";
	Integration$1["Box"] = "BOX";
	Integration$1["Calcom"] = "CALCOM";
	Integration$1["Confluence"] = "CONFLUENCE";
	Integration$1["Deepgram"] = "DEEPGRAM";
	Integration$1["Dropbox"] = "DROPBOX";
	Integration$1["Entraid"] = "ENTRAID";
	Integration$1["Exchange"] = "EXCHANGE";
	Integration$1["Google"] = "GOOGLE";
	Integration$1["GoogleAddon"] = "GOOGLE_ADDON";
	Integration$1["GoogleDrive"] = "GOOGLE_DRIVE";
	Integration$1["Hubspot"] = "HUBSPOT";
	Integration$1["Jira"] = "JIRA";
	Integration$1["Meet"] = "MEET";
	Integration$1["Microsoft"] = "MICROSOFT";
	Integration$1["MicrosoftPlanner"] = "MICROSOFT_PLANNER";
	Integration$1["Nylas"] = "NYLAS";
	Integration$1["Onedrive"] = "ONEDRIVE";
	Integration$1["Openai"] = "OPENAI";
	Integration$1["Outlook"] = "OUTLOOK";
	Integration$1["Recallai"] = "RECALLAI";
	Integration$1["Salesforce"] = "SALESFORCE";
	Integration$1["Slack"] = "SLACK";
	Integration$1["Teams"] = "TEAMS";
	Integration$1["TeamsAddon"] = "TEAMS_ADDON";
	Integration$1["Trello"] = "TRELLO";
	Integration$1["Webex"] = "WEBEX";
	Integration$1["Zoom"] = "ZOOM";
	return Integration$1;
}({});
let SortEnumType = /* @__PURE__ */ function(SortEnumType$1) {
	SortEnumType$1["Asc"] = "ASC";
	SortEnumType$1["Desc"] = "DESC";
	return SortEnumType$1;
}({});
let User_UserStatus = /* @__PURE__ */ function(User_UserStatus$1) {
	User_UserStatus$1["Active"] = "ACTIVE";
	User_UserStatus$1["Deactivated"] = "DEACTIVATED";
	User_UserStatus$1["Pending"] = "PENDING";
	User_UserStatus$1["PendingToDelete"] = "PENDING_TO_DELETE";
	return User_UserStatus$1;
}({});
const AddActionItemDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "AddActionItem"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "CreateActionInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "createAction"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "createActionInput"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "action"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "meetingId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "title"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "dueDate"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "assignees"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "userId"
											}
										}]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "completeStatus"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "isCompleted"
											}
										}, {
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "completedAtUtc"
											}
										}]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "priority"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "reactions"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactionSymbol"
											}
										}, {
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactors"
											},
											"selectionSet": {
												"kind": "SelectionSet",
												"selections": [{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "userId"
													}
												}]
											}
										}]
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
const AddAgendaItemDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "AddAgendaItem"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "AddAgendaItemInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "addAgendaItem"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "agendaItemInput"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "agendaItem"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const CreateAttachmentDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "CreateAttachment"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "CreateAttachmentInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "createAttachment"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "createAttachmentInput"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "attachment"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const CreateDecisionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "CreateDecision"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "CreateDecisionInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "createDecision"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "createDecisionInput"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "decision"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const GetMeetingDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "query",
		"name": {
			"kind": "Name",
			"value": "GetMeeting"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "ViewMeetingInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "meeting"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "meeting"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "content"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "contentBody"
											}
										}]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "allAttachments"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "title"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "size"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "attachmentPath"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "comments"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "nodes"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															}]
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "links"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "linkEntityId"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "linkType"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "linkEntityType"
															}
														}
													]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "tags"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "nodes"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "tagId"
																}
															}]
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "reactions"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "reactionSymbol"
														}
													}, {
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "reactors"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "userId"
																}
															}, {
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "user"
																},
																"selectionSet": {
																	"kind": "SelectionSet",
																	"selections": [{
																		"kind": "Field",
																		"name": {
																			"kind": "Name",
																			"value": "firstName"
																		}
																	}, {
																		"kind": "Field",
																		"name": {
																			"kind": "Name",
																			"value": "lastName"
																		}
																	}]
																}
															}]
														}
													}]
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "agenda"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "name"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "isCompleted"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "duration"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "createdDate"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "speakers"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "user"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "id"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "firstName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "lastName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "email"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "imageUrl"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "role"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "meetplaceId"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "jobTitle"
																	}
																}
															]
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "comments"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "nodes"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															}]
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "links"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "linkEntityId"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "linkType"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "linkEntityType"
															}
														}
													]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "tags"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "nodes"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "tagId"
																}
															}]
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "reactions"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "reactionSymbol"
														}
													}, {
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "reactors"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "userId"
																}
															}]
														}
													}]
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "actions"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "title"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "dueDate"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "completeStatus"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "isCompleted"
														}
													}, {
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "completedAtUtc"
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "assignees"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "user"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "id"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "firstName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "lastName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "email"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "imageUrl"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "role"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "meetplaceId"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "jobTitle"
																	}
																}
															]
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "comments"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "nodes"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															}]
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "links"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "linkEntityId"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "linkType"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "linkEntityType"
															}
														}
													]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "tags"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "nodes"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "tagId"
																}
															}]
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "reactions"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "reactionSymbol"
														}
													}, {
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "reactors"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "userId"
																}
															}]
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "jiraLinkage"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "linked"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "key"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "url"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "needsResync"
															}
														}
													]
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "notes"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "links"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "linkType"
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "tags"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "nodes"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "tagId"
																}
															}]
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "comments"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "nodes"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															}]
														}
													}]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "reactions"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "reactionSymbol"
														}
													}, {
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "reactors"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "userId"
																}
															}]
														}
													}]
												}
											}
										]
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
const SendMentionsDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "SendMentions"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "SendMentionsEmailInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "sendMentionsEmails"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "emailsSent"
						}
					}]
				}
			}]
		}
	}]
};
const CreateNoteDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "CreateNote"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "CreateNoteInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "createNote"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "createNoteInput"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "note"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const AddPollItemDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "AddPollItem"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "CreatePollInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "createPoll"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "poll"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "meetingId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "question"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "options"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "isTransient"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "name"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "voters"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "userId"
														}
													}, {
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "user"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "id"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "firstName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "lastName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "email"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "imageUrl"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "role"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "meetplaceId"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "jobTitle"
																	}
																}
															]
														}
													}]
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "reactions"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactionSymbol"
											}
										}, {
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactors"
											},
											"selectionSet": {
												"kind": "SelectionSet",
												"selections": [{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "userId"
													}
												}, {
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "user"
													},
													"selectionSet": {
														"kind": "SelectionSet",
														"selections": [
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "firstName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "lastName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "email"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "imageUrl"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "role"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isConfirmedEmail"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "meetplaceId"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isConfirmedEmail"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "jobTitle"
																}
															}
														]
													}
												}]
											}
										}]
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
const ActionIntegrationLinkedDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "subscription",
		"name": {
			"kind": "Name",
			"value": "ActionIntegrationLinked"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "actionId"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UUID"
					}
				}
			}
		}, {
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "excludeMeetingRoomChange"
				}
			},
			"type": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "Boolean"
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "actionIntegrationLinkedV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "actionId"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "actionId"
						}
					}
				}, {
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "excludeMeetingRoomChange"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "excludeMeetingRoomChange"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "action"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}, {
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "integrations"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "linked"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "integrationId"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "key"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "lastSynced"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "linked"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "logo"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "needsResync"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "url"
											}
										}
									]
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const AssistantPromptDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "query",
		"name": {
			"kind": "Name",
			"value": "AssistantPrompt"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "AssistantPromptInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "assistantPrompt"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "text"
						}
					}]
				}
			}]
		}
	}]
};
const SubmitAiPromptFeedbackDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "SubmitAiPromptFeedback"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "SubmitAiPromptFeedbackInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "submitAiPromptFeedback"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}]
			}]
		}
	}]
};
const AddPollVoteDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "AddPollVote"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "AddPollVoteInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "addPollVote"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "poll"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "meetingId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "question"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "isPollEnded"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "options"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "isTransient"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "name"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "voters"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "userId"
														}
													}, {
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "user"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "id"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "fullName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "displayName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "firstName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "lastName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "email"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "imageUrl"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "role"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "meetplaceId"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationInvalid"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationExpired"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "jobTitle"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "userStatus"
																	}
																}
															]
														}
													}]
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "reactions"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactionSymbol"
											}
										}, {
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactors"
											},
											"selectionSet": {
												"kind": "SelectionSet",
												"selections": [{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "userId"
													}
												}, {
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "user"
													},
													"selectionSet": {
														"kind": "SelectionSet",
														"selections": [
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "fullName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "displayName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "firstName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "lastName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "email"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "imageUrl"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "role"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "meetplaceId"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isConfirmedEmail"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isMeetplaceInvitationInvalid"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isMeetplaceInvitationExpired"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "jobTitle"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "userStatus"
																}
															}
														]
													}
												}]
											}
										}]
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
const UpdatePollVoteDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "UpdatePollVote"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UpdatePollVoteInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "updatePollVote"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "poll"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "meetingId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "question"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "isPollEnded"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "options"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "isTransient"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "name"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "voters"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "userId"
														}
													}, {
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "user"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "id"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "fullName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "displayName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "firstName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "lastName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "email"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "imageUrl"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "role"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "meetplaceId"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationInvalid"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationExpired"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "jobTitle"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "userStatus"
																	}
																}
															]
														}
													}]
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "reactions"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactionSymbol"
											}
										}, {
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactors"
											},
											"selectionSet": {
												"kind": "SelectionSet",
												"selections": [{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "userId"
													}
												}, {
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "user"
													},
													"selectionSet": {
														"kind": "SelectionSet",
														"selections": [
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "fullName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "displayName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "firstName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "lastName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "email"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "imageUrl"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "role"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "meetplaceId"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isConfirmedEmail"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isMeetplaceInvitationInvalid"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isMeetplaceInvitationExpired"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "jobTitle"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "userStatus"
																}
															}
														]
													}
												}]
											}
										}]
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
const RemovePollVoteDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "RemovePollVote"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "RemovePollVoteInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "removePollVote"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "poll"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "meetingId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "question"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "isPollEnded"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "options"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "isTransient"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "name"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "voters"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "userId"
														}
													}, {
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "user"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "id"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "fullName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "displayName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "firstName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "lastName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "email"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "imageUrl"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "role"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "meetplaceId"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationInvalid"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationExpired"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "jobTitle"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "userStatus"
																	}
																}
															]
														}
													}]
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "reactions"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactionSymbol"
											}
										}, {
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactors"
											},
											"selectionSet": {
												"kind": "SelectionSet",
												"selections": [{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "userId"
													}
												}, {
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "user"
													},
													"selectionSet": {
														"kind": "SelectionSet",
														"selections": [
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "fullName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "displayName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "firstName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "lastName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "email"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "imageUrl"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "role"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "meetplaceId"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isConfirmedEmail"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isMeetplaceInvitationInvalid"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isMeetplaceInvitationExpired"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "jobTitle"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "userStatus"
																}
															}
														]
													}
												}]
											}
										}]
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
const UpdatePollDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "UpdatePoll"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "EditPollInputV2Input"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "editPollV2"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "poll"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "meetingId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "question"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "isPollEnded"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "options"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "isTransient"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "name"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "voters"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "userId"
														}
													}, {
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "user"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "id"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "fullName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "displayName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "firstName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "lastName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "email"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "imageUrl"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "role"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "meetplaceId"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationInvalid"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationExpired"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "jobTitle"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "userStatus"
																	}
																}
															]
														}
													}]
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "reactions"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactionSymbol"
											}
										}, {
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactors"
											},
											"selectionSet": {
												"kind": "SelectionSet",
												"selections": [{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "userId"
													}
												}, {
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "user"
													},
													"selectionSet": {
														"kind": "SelectionSet",
														"selections": [
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "fullName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "displayName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "firstName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "lastName"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "email"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "imageUrl"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "role"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "meetplaceId"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isConfirmedEmail"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isMeetplaceInvitationInvalid"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "isMeetplaceInvitationExpired"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "jobTitle"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "userStatus"
																}
															}
														]
													}
												}]
											}
										}]
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
const GetUserDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "query",
		"name": {
			"kind": "Name",
			"value": "GetUser"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "userId"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UUID"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "user"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "userId"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "userId"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "id"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "email"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "displayName"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "firstName"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "lastName"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "imageUrl"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "meetplaceId"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "role"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "jobTitle"
							}
						}
					]
				}
			}]
		}
	}]
};
const GenerateDownloadUrlDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "generateDownloadUrl"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "GenerateDownloadableUrlInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "generateDownloadUrl"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "downloadableUrl"
						}
					}]
				}
			}]
		}
	}]
};
const SearchContentDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "query",
		"name": {
			"kind": "Name",
			"value": "searchContent"
		},
		"variableDefinitions": [
			{
				"kind": "VariableDefinition",
				"variable": {
					"kind": "Variable",
					"name": {
						"kind": "Name",
						"value": "first"
					}
				},
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "Int"
					}
				}
			},
			{
				"kind": "VariableDefinition",
				"variable": {
					"kind": "Variable",
					"name": {
						"kind": "Name",
						"value": "where"
					}
				},
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UniversalSearchFilterInput"
					}
				}
			},
			{
				"kind": "VariableDefinition",
				"variable": {
					"kind": "Variable",
					"name": {
						"kind": "Name",
						"value": "universalSearchFilterInput"
					}
				},
				"type": {
					"kind": "NonNullType",
					"type": {
						"kind": "NamedType",
						"name": {
							"kind": "Name",
							"value": "UniversalSearchCustomFilterInput"
						}
					}
				}
			}
		],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "searchContent"
				},
				"arguments": [
					{
						"kind": "Argument",
						"name": {
							"kind": "Name",
							"value": "first"
						},
						"value": {
							"kind": "Variable",
							"name": {
								"kind": "Name",
								"value": "first"
							}
						}
					},
					{
						"kind": "Argument",
						"name": {
							"kind": "Name",
							"value": "where"
						},
						"value": {
							"kind": "Variable",
							"name": {
								"kind": "Name",
								"value": "where"
							}
						}
					},
					{
						"kind": "Argument",
						"name": {
							"kind": "Name",
							"value": "universalSearchFilterInput"
						},
						"value": {
							"kind": "Variable",
							"name": {
								"kind": "Name",
								"value": "universalSearchFilterInput"
							}
						}
					}
				],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "nodes"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "_id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "title"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "type"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "meetingId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "meeting"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "meetingStartDateUtc"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "meetingEndDateUtc"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "isAllDay"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "title"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "groupType"
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
const FilterUsersDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "query",
		"name": {
			"kind": "Name",
			"value": "FilterUsers"
		},
		"variableDefinitions": [
			{
				"kind": "VariableDefinition",
				"variable": {
					"kind": "Variable",
					"name": {
						"kind": "Name",
						"value": "where"
					}
				},
				"type": {
					"kind": "NonNullType",
					"type": {
						"kind": "NamedType",
						"name": {
							"kind": "Name",
							"value": "UserFilterInput"
						}
					}
				}
			},
			{
				"kind": "VariableDefinition",
				"variable": {
					"kind": "Variable",
					"name": {
						"kind": "Name",
						"value": "first"
					}
				},
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "Int"
					}
				}
			},
			{
				"kind": "VariableDefinition",
				"variable": {
					"kind": "Variable",
					"name": {
						"kind": "Name",
						"value": "order"
					}
				},
				"type": {
					"kind": "ListType",
					"type": {
						"kind": "NonNullType",
						"type": {
							"kind": "NamedType",
							"name": {
								"kind": "Name",
								"value": "UserSortInput"
							}
						}
					}
				}
			}
		],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "users"
				},
				"arguments": [
					{
						"kind": "Argument",
						"name": {
							"kind": "Name",
							"value": "where"
						},
						"value": {
							"kind": "Variable",
							"name": {
								"kind": "Name",
								"value": "where"
							}
						}
					},
					{
						"kind": "Argument",
						"name": {
							"kind": "Name",
							"value": "first"
						},
						"value": {
							"kind": "Variable",
							"name": {
								"kind": "Name",
								"value": "first"
							}
						}
					},
					{
						"kind": "Argument",
						"name": {
							"kind": "Name",
							"value": "order"
						},
						"value": {
							"kind": "Variable",
							"name": {
								"kind": "Name",
								"value": "order"
							}
						}
					}
				],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "nodes"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "email"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "displayName"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "firstName"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "lastName"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "imageUrl"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "meetplaceId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "userStatus"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "role"
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
const GetUsersDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "query",
		"name": {
			"kind": "Name",
			"value": "GetUsers"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "order"
				}
			},
			"type": {
				"kind": "ListType",
				"type": {
					"kind": "NonNullType",
					"type": {
						"kind": "NamedType",
						"name": {
							"kind": "Name",
							"value": "UserSortInput"
						}
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "users"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "order"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "order"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "nodes"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "email"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "displayName"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "firstName"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "lastName"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "fullName"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "imageUrl"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "meetplaceId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "userStatus"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "role"
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
const AddAgendaReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "AddAgendaReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "ReactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "addAgendaReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "agendaItem"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const RemoveAgendaReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "RemoveAgendaReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UnreactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "removeAgendaReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "agendaItem"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const AddActionReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "AddActionReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "ReactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "addActionReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "action"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const RemoveActionReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "RemoveActionReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UnreactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "removeActionReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "action"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const AddDecisionReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "AddDecisionReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "ReactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "addDecisionReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "decision"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const RemoveDecisionReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "RemoveDecisionReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UnreactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "removeDecisionReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "decision"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const AddAttachmentReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "AddAttachmentReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "ReactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "addAttachmentReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "attachment"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const RemoveAttachmentReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "RemoveAttachmentReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UnreactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "removeAttachmentReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "attachment"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const AddPollReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "AddPollReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "ReactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "addPollReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "poll"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const RemovePollReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "RemovePollReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UnreactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "removePollReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "poll"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const AddNoteReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "AddNoteReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "ReactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "addNoteReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "note"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const RemoveNoteReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "RemoveNoteReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UnreactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "removeNoteReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "note"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const AddMessageReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "addMessageReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "ReactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "addMessageReaction"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "reactInput"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "chatMessage"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const RemoveMessageReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "removeMessageReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UnreactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "removeMessageReaction"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "unreactInput"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "chatMessage"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
const AddCommentReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "addCommentReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "ReactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "addCommentReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "comment"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "contentType"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "contentId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "reactions"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactionSymbol"
											}
										}, {
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactors"
											},
											"selectionSet": {
												"kind": "SelectionSet",
												"selections": [
													{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "userId"
														}
													},
													{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "email"
														}
													},
													{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "createdDate"
														}
													},
													{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "user"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "id"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "fullName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "firstName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "lastName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "email"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "imageUrl"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "role"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "meetplaceId"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationInvalid"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationExpired"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "jobTitle"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "userStatus"
																	}
																}
															]
														}
													}
												]
											}
										}]
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
const RemoveCommentReactionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "removeCommentReaction"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UnreactInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "removeCommentReactionV1"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "comment"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "contentType"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "contentId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "reactions"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactionSymbol"
											}
										}, {
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "reactors"
											},
											"selectionSet": {
												"kind": "SelectionSet",
												"selections": [
													{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "userId"
														}
													},
													{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "email"
														}
													},
													{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "createdDate"
														}
													},
													{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "user"
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "id"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "fullName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "firstName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "lastName"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "email"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "imageUrl"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "role"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "meetplaceId"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isConfirmedEmail"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationInvalid"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "isMeetplaceInvitationExpired"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "jobTitle"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "userStatus"
																	}
																}
															]
														}
													}
												]
											}
										}]
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};

//#endregion
export { ActionIntegrationLinkedDocument, AddActionItemDocument, AddActionReactionDocument, AddAgendaItemDocument, AddAgendaReactionDocument, AddAttachmentReactionDocument, AddCommentReactionDocument, AddDecisionReactionDocument, AddMessageReactionDocument, AddNoteReactionDocument, AddPollItemDocument, AddPollReactionDocument, AddPollVoteDocument, AssistantPromptDocument, CreateAttachmentDocument, CreateDecisionDocument, CreateNoteDocument, FilterUsersDocument, GenerateDownloadUrlDocument, GetMeetingDocument, GetUserDocument, GetUsersDocument, Integration, RemoveActionReactionDocument, RemoveAgendaReactionDocument, RemoveAttachmentReactionDocument, RemoveCommentReactionDocument, RemoveDecisionReactionDocument, RemoveMessageReactionDocument, RemoveNoteReactionDocument, RemovePollReactionDocument, RemovePollVoteDocument, SearchContentDocument, SendMentionsDocument, SortEnumType, SubmitAiPromptFeedbackDocument, UpdatePollDocument, UpdatePollVoteDocument, User_UserStatus };
//# sourceMappingURL=graphql.js.map